import { Box, Typography } from '@mui/material';
import { DS } from './ds';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

const PageHeader = ({ title, subtitle }: PageHeaderProps) => (
  <Box mb={4}>
    <Typography variant="h4" fontWeight={800} color={DS.blue} gutterBottom>
      {title}
    </Typography>
    {subtitle && (
      <Typography color={DS.textSecondary} fontSize={15}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default PageHeader;
